
import { Box, Container, Divider, Link, Stack, Typography } from "@mui/material";

const Footer = () => {
    return (
        <Box component="footer" sx={{ backgroundColor: "#f5f5f5", py: 2 }}>
            <Container maxWidth="lg">

                <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
                    <Typography variant="body2" color="black">
                        Email:{" "}
                        <Link
                            href="mailto:canberrahebronchurch@gmail.com"
                            sx={{ color: "#b37a4c", fontWeight: "bold", textDecoration: "none", "&:hover": { color: "blue" } }}
                        >
                            canberrahebronchurch@gmail.com
                        </Link>
                    </Typography>
                    <Typography variant="body2" color="black" sx={{ mt: { xs: 0.5, sm: 0 } }}>
                        Tel: {" "} <span sx={{ color: "#b37a4c", fontWeight: "bold" }}>0435758127</span>

                    </Typography>
                </Stack>

               
                <Divider sx={{ my: 2 }} />


              
                <Stack
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    textAlign="center"
                >
                    <Typography variant="body2" color="textSecondary">
                        © {new Date().getFullYear()} Canberra Hebron Church. All rights reserved.
                    </Typography>
                </Stack>

            </Container>
        </Box>
    );
};

export default Footer;
